import HtmlIcon from "@mui/icons-material/Html";
import MediationIcon from "@mui/icons-material/Mediation";
import { FaReact } from "react-icons/fa";
import { TbBrandCpp } from "react-icons/tb";
import {
  SiJavascript,
  SiTailwindcss,
  SiCss3,
  SiNodedotjs,
  SiMongodb,
  SiFirebase,
  SiPython,
  SiPostman,
} from "react-icons/si";

import firebase from "./images/Firebase.png";
import academia from "./images/acdemia.png";
import portfolio from "./images/Portfolio.png";
// Navigation Data
const navigation = [
  { name: "home", href: "#home" },
  { name: "skills", href: "#skills" },
  { name: "projects", href: "#project" },
  { name: "contact", href: "#contact" },
];

// Skills Data
const skillData = [
  {
    title: "Pro",
    name: "C++",
    end: "60",
    desc: "Basic Knowledge",
    icon: <TbBrandCpp />,
  },
  {
    title: "Pro",
    name: "DSA",
    end: "60",
    desc: "Basic Knowledge",
    icon: <MediationIcon />,
  },
  {
    title: "Pro",
    name: "Python",
    end: "60",
    desc: "Basic Knowledge",
    icon: <SiPython />,
  },
  {
    title: "web",
    name: "HTML",
    end: "90",
    desc: "Lorem ipsum, dolor sit amet consectetur adipisicing elit. Esse, culpa!",
    icon: <HtmlIcon />,
  },
  {
    title: "web",
    name: "JS",
    end: "80",
    desc: "Lorem ipsum, dolor sit amet consectetur adipisicing elit. Esse, culpa!",
    icon: <SiJavascript />,
  },
  {
    title: "web",
    name: "CSS",
    end: "90",
    desc: "Lorem ipsum, dolor sit amet consectetur adipisicing elit. Esse, culpa!",
    icon: <SiCss3 />,
  },
  {
    title: "web",
    name: "React",
    end: "85",
    desc: "Lorem ipsum, dolor sit amet consectetur adipisicing elit. Esse, culpa!",
    icon: <FaReact />,
  },
  {
    title: "web",
    name: "TailwindCss",
    end: "85",
    desc: "Lorem ipsum, dolor sit amet consectetur adipisicing elit. Esse, culpa!",
    icon: <SiTailwindcss />,
  },
  {
    title: "web",
    name: "NodeJs",
    end: "70",
    desc: "Lorem ipsum, dolor sit amet consectetur adipisicing elit. Esse, culpa!",
    icon: <SiNodedotjs />,
  },
  {
    title: "web",
    name: "MongoDB",
    end: "70",
    desc: "Lorem ipsum, dolor sit amet consectetur adipisicing elit. Esse, culpa!",
    icon: <SiMongodb />,
  },

  {
    title: "web",
    name: "Firebase",
    end: "40",
    desc: "Basic Knowledge",
    icon: <SiFirebase />,
  },
  {
    title: "web",
    name: "Postman",
    end: "65",
    desc: "Lorem ipsum, dolor sit amet consectetur adipisicing elit. Esse, culpa!",
    icon: <SiPostman />,
  },
];

const skills = [
  {
    index: 1,
    title: "WebDevelopment",
    name: "web",
  },
  {
    index: 2,
    title: "Programming",
    name: "Pro",
  },
];

// Project Data

const project = [
  {
    num: "1",
    name: "Academia Stacks",
    desc: "Developed a college note aggregation website in 20 days with a friend. As primary frontend developer, created an intuitive user interface and played key role in connecting backend to frontend.",
    link: "https://academia-stacks.vercel.app/",
    image: academia,
    github: "https://github.com/hellovaibhav/AcademiaStacks",
  },
  {
    num: "2",
    name: "FireBase Authentication",
    desc: "I was asked by a company to develop a Firebase authentication app by a company on internshala as a project . Without any prior experience in Firebase I was able to make it within the given time span with the help of documentations and tutorials .",
    link: "https://fir-authentication-app-f9489.web.app/",
    image: firebase,
    github: "https://github.com/Saquib1973/Firebase_Authentication_App",
  },
  {
    num: "3",
    name: "Portfolio",
    desc: "",
    link: "https://fir-authentication-app-f9489.web.app/",
    image: portfolio,
    github: "https://github.com/Saquib1973/saquib-portfolio",
  },
];

export { navigation, skills, project, skillData };
